import { z } from 'zod';

import { STAGE_KINDS } from '@/lib/stage-kind';

// Contratos del cronómetro de etapa (so=420, spec §3.1) validados con Zod: una
// respuesta con forma inesperada cae al error de la tarjeta, nunca a una excepción en
// el render.

export { STAGE_KINDS, type StageKind } from '@/lib/stage-kind';

export const SESSION_STATES = ['active', 'paused', 'idle'] as const;
export type SessionState = (typeof SESSION_STATES)[number];

const seconds = z.number().int().nonnegative();

const openClockSchema = z.object({
  open: z.literal(true),
  stageKind: z.enum(STAGE_KINDS),
  workStage: z.boolean(),
  attempt: z.number().int().positive(),
  isReproceso: z.boolean(),
  openedAt: z.string(),
  serverNow: z.string(),
  macroSeconds: seconds,
  heartbeatIntervalSeconds: z.number().int().positive(),
  idleTimeoutSeconds: z.number().int().positive(),
  mine: z.object({
    session: z.enum(SESSION_STATES),
    effortSeconds: seconds,
    pauseCount: seconds,
  }),
  totalEffortSeconds: seconds,
  /** Esfuerzo de toda la etapa, con todos sus intentos (spec 2026-10-14 §7 D2). */
  stageEffortSeconds: seconds,
});
export type OpenClock = z.infer<typeof openClockSchema>;

export const clockSchema = z.discriminatedUnion('open', [
  z.object({ open: z.literal(false) }),
  openClockSchema,
]);
export type ClockView = z.infer<typeof clockSchema>;

export const clockResponseSchema = z.object({ success: z.literal(true), data: clockSchema });

export const trackResponseSchema = z.object({
  success: z.literal(true),
  data: z.discriminatedUnion('tracking', [
    z.object({ tracking: z.literal(true), stageKind: z.enum(STAGE_KINDS) }),
    z.object({ tracking: z.literal(false), reason: z.string() }),
  ]),
});

export const pauseResponseSchema = z.object({
  success: z.literal(true),
  data: z.object({ paused: z.boolean() }),
});
